/** Chromium's install event; not in the DOM typings. */
export interface InstallEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

interface Snapshot {
  event: InstallEvent | null;
  installed: boolean;
}

const isStandalone = () => (typeof matchMedia === 'function' && matchMedia('(display-mode: standalone)').matches) || (navigator as { standalone?: boolean }).standalone === true;

const listeners = new Set<() => void>();
let snapshot: Snapshot = { event: null, installed: isStandalone() };

function update(next: Partial<Snapshot>): void {
  snapshot = { ...snapshot, ...next };
  listeners.forEach((l) => l());
}

// The browser fires `beforeinstallprompt` once, soon after load. Listening here, when the app boots, keeps the event
// until a screen wants it; a listener that only starts on the screen with the button would usually miss it.
addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault(); // keep it for our own button
  update({ event: e as InstallEvent });
});
addEventListener('appinstalled', () => update({ event: null, installed: true }));

export const installStore = {
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => void listeners.delete(listener);
  },
  getSnapshot: (): Snapshot => snapshot,
  /** The browser allows one prompt per event, so it is dropped once used. */
  consume(accepted: boolean): void {
    update({ event: null, installed: snapshot.installed || accepted });
  },
};
